export const API_ASSETS_PREFIX = '';
